// OrderItem.js
import React from "react";

// MUI components
import { Typography } from "@material-ui/core";

// // Local components
import { OrderItemComponent } from "./OrderItemComponent";

export const OrderSection = ({ title, orders, titleColor = "#374151" }) => {
	if (orders.length === 0) return null;

	return (
		<>
			<Typography
				style={{
					color: titleColor,
					fontSize: "12px",
					fontWeight: "600",
					marginBottom: "10px",
					textTransform: "uppercase",
					letterSpacing: "0.3px",
				}}
			>
				{title}
			</Typography>
			{orders.map((orderData) => (
				<OrderItemComponent key={orderData.order.id} {...orderData} />
			))}
		</>
	);
};